import type { CoreApiClient } from "../client";
import { createBoilerRoomMutations } from "../mutations/boiler-room.mutations";
import { createBoilerRoomQueries } from "../queries/boiler-room.queries";

export const createBoilerRoomRepository = (api: CoreApiClient) => ({
  ...createBoilerRoomQueries(api),
  ...createBoilerRoomMutations(api),
});
